import { getFullUrl } from 'hubspot-url-utils';
import { useTranslation } from '../../../hooks/useNavConfig';
import { AccountExtraLink } from './AccountExtrasLink';
import useHomePath from '../../../hooks/useHomePath';
import { isGlobalNavAcademyMode } from '../../../utils/navEnviro';
import { useAppSelector } from '../../../hooks';
import { selectGates } from '../../../reducers/Portal';
import { jsx as _jsx } from "react/jsx-runtime";
export const AcademyLink = ({
  portalId,
  isDevPortal
}) => {
  const {
    t
  } = useTranslation();
  const homePath = useHomePath();
  const gates = useAppSelector(selectGates);
  const isAcademyMode = isGlobalNavAcademyMode(gates);
  if (isDevPortal || !homePath) {
    return null;
  }
  return /*#__PURE__*/_jsx(AccountExtraLink, {
    id: "academy",
    link: isAcademyMode && homePath ? homePath : `${getFullUrl('app')}/academy/${portalId}?LC004=Control`,
    linkText: isAcademyMode && homePath ? t('nav.account.hubspotSoftware') : t('nav.tools.academy'),
    isExternal: !(isAcademyMode && homePath)
  });
};